import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import WashingMachineService from './pages/WashingMachineService.js';
import FridgeService from './pages/FridgeService.js';
import ContactPage from './pages/ContactPage.js';
import AboutPage from './pages/AboutPage.js';
import TermsAndConditions from './components/TermsAndConditions.js';

import PrivacyPolicy from './components/PrivacyPolicy.js';
import ScrollToTop from './components/ScrollToTop.js'; 

function App() {
  return (
    <Router> 
      <div>
        <Header />
        <ScrollToTop /> {/* Add ScrollToTop component here */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/washing-machine-service" element={<WashingMachineService />} />
          <Route path="/fridge-service" element={<FridgeService />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
